import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';

const AgregarRangoEdad = ({title, openFullScreenDialog, handleClose, medioDeComunicacion, validarTipoDeTarifario, accionRegistroGuardado, cerrarModalPorError}) => {
    const dispatch = useDispatch();
    const {datosGenerales} = useSelector((state) => state);
    const [catalogoRangoDeEdades] = useState('catalogoRangoDeEdades');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);

        useEffect(() => {
        obtenerRangoDeEdades();
    },[])

    const obtenerRangoDeEdades = async () => {
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        if(datosGenerales.rangoDeEdades.length > 0) {
            copiaDeCampos.edades.list = datosGenerales.rangoDeEdades?.map( ({id, rango}) => ({id: id , name: rango}) );
            return setCamposDelFormulario(copiaDeCampos);
        }

        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPersonalizado({
            controller: catalogoRangoDeEdades,
            validateIfDataExists: true,
            stateInStore: datosGenerales.rangoDeEdades,
            dispatchAction: nombreDeAcciones.SETEAR_RANGO_DE_EDADES,
            nombreDelMetodo: "listar",
        }));

        setcargandoSolicitud(false);

        if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

        copiaDeCampos.edades.list = respuesta?.data?.map( ({id, rango}) => ({id , name: rango}) )
        setCamposDelFormulario(copiaDeCampos);
    }

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        edades: {
            idelement: "edades", value: null , label: "Seleccione el rango de edad *", pattern:"", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '100%', marginTop: '1%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const guardarDatos = async (datosDelFormulario) => {
        setcargandoSolicitud(true);

        const { edades } = datosDelFormulario;

        const controllerMedio = validarTipoDeTarifario();

        const datosAEnviar = {
            controller: controllerMedio, action: "crear",
            data: {},
            nombreDelMetodo: `crear/audienciaPorEdad/${medioDeComunicacion?.id || ""}/${edades?.id || ""}`
        };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));

        setcargandoSolicitud(false);
        if(respuesta?.error) return cerrarModalPorError(respuesta)
        accionRegistroGuardado(respuesta?.data)
    }

    const [listaDeBotones]= React.useState({
        "guardarDatos":{"label":"Guardar datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setDatosDeRespuesta({errorType,messageType,openResponse,})
    };

    const { errorType, messageType, openResponse} = datosDeRespuesta;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            maxWidth="md"
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={camposDelFormulario}
                            buttonList={listaDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default AgregarRangoEdad;